import { createFeature, createReducer, on, createSelector, createAction, props } from '@ngrx/store';
import { CommonApiState } from './common';
import { WorkspaceDocumentsResponse } from '../models/documents';

export const WorkspaceSourceDocFetch = createAction('[WorkspaceSourceDoc] Fetch', props<{ workspaceId: string }>());
export const WorkspaceSourceDocFetched = createAction(
  '[WorkspaceSourceDoc] Fetched',
  props<{ workspaceId: string; workspaceSourceDoc: WorkspaceDocumentsResponse }>()
);
export const WorkspaceSourceDocError = createAction('[WorkspaceSourceDoc] Error', props<{ workspaceId: string }>());

export const initialState: Record<string, CommonApiState<WorkspaceDocumentsResponse>> = {};

export const workspaceSourceDocFeature = createFeature({
  name: 'workspaceSourceDoc',
  reducer: createReducer(
    initialState,
    on(WorkspaceSourceDocFetch, (state, action) => ({
      ...state,
      [action.workspaceId]: {
        ...(state[action.workspaceId] ?? {}),
        currentPedingApis: (state[action.workspaceId]?.currentPedingApis ?? 0) + 1
      }
    })),
    on(WorkspaceSourceDocFetched, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          data: action.workspaceSourceDoc
        }
      };
    }),
    on(WorkspaceSourceDocError, (state, action) => {
      return {
        ...state,
        [action.workspaceId]: {
          ...(state[action.workspaceId] ?? {}),
          currentPedingApis: 0,
          isError: true
        }
      };
    })
  ),
  extraSelectors: ({ selectWorkspaceSourceDocState }) => {
    const workspaceSourceDocIsLoading = (workspaceId: string) =>
      createSelector(
        selectWorkspaceSourceDocState,
        workspaceSourceDocState => (workspaceSourceDocState[workspaceId]?.currentPedingApis ?? 0) > 0
      );

    const workspaceSourceDocHasPendingRequest = (workspaceId: string) =>
      createSelector(
        selectWorkspaceSourceDocState,
        workspaceSourceDocState => (workspaceSourceDocState[workspaceId]?.currentPedingApis ?? 0) >= 2
      );

    const workspaceSourceDocData = (workspaceId: string) => {
      return createSelector(selectWorkspaceSourceDocState, workspaceSourceDocState => {
        return workspaceSourceDocState[workspaceId]?.data;
      });
    };
    const workspaceSourceIsError = (workspaceId: string) => {
      return createSelector(selectWorkspaceSourceDocState, workspaceSourceDocState => {
        return workspaceSourceDocState[workspaceId]?.isError;
      });
    };

    return {
      workspaceSourceDocIsLoading: workspaceSourceDocIsLoading,
      workspaceSourceDocHasPendingRequest: workspaceSourceDocHasPendingRequest,
      workspaceSourceDocData: workspaceSourceDocData,
      workspaceSourceIsError
    };
  }
});
